/*
 * Action Types
 */
export enum SearchsTypes {
  SET_SELECTED_ITEMS = '@searchs/SET_SELECTED_ITEMS',
}

/*
 * Data types
 */

export interface SearchItemsFilterInterface {
  key: string;
  value: string;
}

/*
 * State type
 */
export interface SearchsState {
  readonly selectedItems: SearchItemsFilterInterface[];
  readonly error: boolean;
  readonly loading: boolean;
}
